import { Service } from "../Service";
import { ApplicationData } from "./ApplicationData";

export class ApplicationDataService extends Service<ApplicationData>
{
}